import React, { FunctionComponent } from 'react'
import styles from './InfoPage.module.sass'
import { processDate } from '../../../utils/date-utils'
import { Link } from 'react-router-dom'
import { ROUTES } from '../../../http/routes'

const InfoPage: FunctionComponent = () => {
    return <div className={styles.page}>
        <Link to={ROUTES.ROOT}>Вернуться на главную</Link>
        <div>Сборка от {processDate(process.env?.BUILD_VERSION)}</div>
    </div>
}

export default InfoPage